import Inputmask from "inputmask";

export class RegistrationChangeInputs {
    constructor(optionalOptions = {}) {
        this._formRegister = document.querySelector('.registration-container--form');
        if (!this._formRegister) {
            this.destructor();
            return true;
        }

        let inputParent
        let inputParentSelect = null
        let inputParentFinal
        let inputs = this._formRegister.querySelectorAll('input')

        if (inputs) {
            for (let i = 0; i < inputs.length; ++i) {
                let input = inputs[i];

                input.addEventListener('keyup', (event) => {
                    inputParent = input.closest('.base-input-wrp')
                    inputParentSelect = input.closest('.base-input-select--wrp')
                    inputParentFinal = (inputParentSelect ? inputParentSelect : inputParent)

                    window.setInputParentStatus(inputParentFinal, '')
                })

                input.addEventListener('change', (event) => {
                    inputParent = input.closest('.base-input-wrp')
                    inputParentSelect = input.closest('.base-input-select--wrp')
                    inputParentFinal = (inputParentSelect ? inputParentSelect : inputParent)

                    window.setInputFloatingLabel(inputParent, '')
                    if (input.value !== '') {
                        window.setInputParentStatus(inputParentFinal, 'success')
                    } else {
                        window.setInputParentStatus(inputParentFinal, '')
                    }
                });
            }
        }

        let phoneElement = this._formRegister.querySelector('[name="phone"]')
        if (phoneElement) {
            Inputmask({
                "clearMaskOnLostFocus": true,
                "clearIncomplete": true,
                "mask": "+7 (999) 999-9999"
            }).mask(phoneElement);
        }
    }

    destructor() {
        this._formRegister = null;
    }
}

export default new RegistrationChangeInputs();
